
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import NativeStartupRedirect from "@/components/NativeStartupRedirect";
import ErrorBoundary from "@/components/ErrorBoundary";
import LandingPage from "./pages/LandingPage";
import LandingPageV2 from "./pages/LandingPageV2";
import LandingPageV3 from "./pages/LandingPageV3";
import LandingPageV4 from "./pages/LandingPageV4";
import LandingPageV5 from "./pages/LandingPageV5";
import WhatIsPACTFramework from "./pages/WhatIsPACTFramework";
import PreOnboarding from "./pages/PreOnboarding";
import EarlyAccessLeads from "./pages/EarlyAccessLeads";
import HomeApp from "./pages/HomeApp";
import GetStarted from "./pages/GetStarted";
import Index from "./pages/Index";
import Statistics from "./pages/Statistics";
import Settings from "./pages/Settings";
import NotFound from "./pages/NotFound";
import Auth from "./pages/Auth";
import Privacy from "./pages/Privacy";
import { Capacitor } from '@capacitor/core';
import TestLogoUpload from "./pages/TestLogoUpload";
import TestWelcomeEmail from "./pages/TestWelcomeEmail";

const queryClient = new QueryClient();

const App = () => (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <NativeStartupRedirect />
          <Routes>
          {/* Landing page oficial */}
          <Route path="/landing-page" element={<LandingPageV5 />} />
          
          {/* Redirects para páginas antiguas */}
          <Route path="/landing-v5" element={<Navigate to="/landing-page" replace />} />
          <Route path="/landing-v4" element={<LandingPageV4 />} />
          <Route path="/landing-v3" element={<LandingPageV3 />} />
          <Route path="/landing-v2" element={<LandingPageV2 />} />
          <Route path="/landing" element={<LandingPage />} />
          
          {/* SEO Content Pages */}
          <Route path="/what-is-pact-framework" element={<WhatIsPACTFramework />} />
          
          {/* Pre-onboarding */}
          <Route path="/early-access" element={<PreOnboarding />} />
          
          {/* Autenticación */}
          <Route path="/auth" element={<Auth />} />
          
          {/* Panel administrativo protegido */}
          <Route path="/early-access-leads" element={
            <ProtectedRoute requireAdmin={true}>
              <EarlyAccessLeads />
            </ProtectedRoute>
          } />
          
          {/* Landing page principal - redirige en web a /landing-page, en nativo a /app */}
          <Route path="/" element={(Capacitor?.isNativePlatform?.() || window.location.protocol === 'capacitor:') ? <Navigate to="/app" replace /> : <Navigate to="/landing-page" replace />} />
          <Route path="/index.html" element={(Capacitor?.isNativePlatform?.() || window.location.protocol === 'capacitor:') ? <Navigate to="/app" replace /> : <Navigate to="/landing-page" replace />} />

          {/* Aplicación móvil */}
          <Route path="/mobile" element={<HomeApp />} />
          <Route path="/get-started" element={<GetStarted />} />
          
          {/* Funcionalidad principal de la app */}
          <Route path="/app" element={<Index />} />
          <Route path="/statistics" element={<Statistics />} />
<Route path="/settings" element={<Settings />} />
<Route path="/privacy" element={<Privacy />} />
<Route path="/test-logo-upload" element={<TestLogoUpload />} />
<Route path="/test-welcome-email" element={<TestWelcomeEmail />} />

{/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
<Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
  </ErrorBoundary>
);

export default App;
